export default "__VITE_ASSET__C4Xv7WGG__"